import InputFileUpload from "components/UI/FileUpload/InputFileUpload";
import React from "react";
import * as XLSX from "xlsx";

type ExcelFileUploadProps = {
  onExcelDataRetrieve: (data: any[]) => void;
};

const ExcelFileUpload: React.FC<ExcelFileUploadProps> = ({
  onExcelDataRetrieve,
}: ExcelFileUploadProps) => {
  const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const data = new Uint8Array(e.target?.result as ArrayBuffer);
        const workbook = XLSX.read(data, { type: "array" });
        const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
        const jsonData = XLSX.utils.sheet_to_json(firstSheet);
        onExcelDataRetrieve(jsonData);
        // console.log("Parsed data:", jsonData);
      } catch (error) {
        console.error("Error parsing Excel file:", error);
      }
    };
    reader.readAsArrayBuffer(file);
  };

  return (
    <div>
      <InputFileUpload onChange={handleFileUpload} upLabel="excel" />
    </div>
  );
};

export default ExcelFileUpload;
